import { useState, useCallback } from 'react';
import quarkusApi from '../../api/quarkusApi';

export function useSaveAgendaBlock() {
  const [isSaving, setSaving] = useState(false);

  const save = useCallback((agendaBlock) => {
    setSaving(true);
    const authHeader = { headers: { Authorization: sessionStorage.getItem('token') } };
    const request = agendaBlock.id
      ? quarkusApi.put('/agenda-blocks', agendaBlock, authHeader)
      : quarkusApi.post('/agenda-blocks', agendaBlock, authHeader);
    return request.finally(() => setSaving(false));
  }, []);

  return { save, isSaving };
}
